import { type QueryObserverOptions, useQuery } from '@tanstack/react-query';
import type { Address } from 'viem';

import FunctionKey from 'constants/functionKey';
import { useChainId, usePublicClient } from 'libs/wallet';

import { getWrapperExchangeRate } from './getWrapperExchangeRate';

interface TrimmedInput {
  wrapperAddress: Address;
}

type Options = QueryObserverOptions<
  bigint,
  Error,
  bigint,
  bigint,
  [FunctionKey.GET_WRAPPER_EXCHANGE_RATE, { chainId: number; wrapperAddress: Address }]
>;

export const useGetWrapperExchangeRate = (
  { wrapperAddress }: TrimmedInput,
  options?: Partial<Options>,
) => {
  const { chainId } = useChainId();
  const { publicClient } = usePublicClient();

  return useQuery({
    queryKey: [FunctionKey.GET_WRAPPER_EXCHANGE_RATE, { chainId, wrapperAddress }],
    queryFn: () => getWrapperExchangeRate({ publicClient, wrapperAddress }),
    ...options,
  });
};
